import { fetchConToken } from "../helpers/fetch";

const TesoreriaService = {
    getUsuariosOspeDirecto: () => {
        return fetchConToken(`Tesoreria/UsuarioOspeDirecto`);
      },
}

export default TesoreriaService; 